module.exports = __webpack_public_path__ + "img/drumlogo3.a8679d81.jpg";